/** @jsx jsx */
import type { Interpolation } from '@emotion/react';
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect } from 'react';

import type { Theme } from '@coursera/cds-core';
import { Grid, SiteNotification, Typography } from '@coursera/cds-core';

import TemporaryLoadingIndicator from 'bundles/onboarding-2022/components/survey/TemporaryLoadingIndicator';
import { LOADING_PAGE_DISPLAY_TIME_MS } from 'bundles/onboarding-2022/data/constants';

import _t from 'i18n!nls/onboarding-2022';

const styles: Record<string, Interpolation<Theme>> = {
  headingText: () => css`
    text-align: center;
    max-width: 15em;
    margin: 170px 0 70px 0;
  `,
  loadingIndicatorWrapper: () => css`
    margin-bottom: 160px;
  `,
  siteNotificationOverrides: () => css`
    padding: 24px 16px !important;
    max-width: 552px;
  `,
};

type Props = {
  onFinishedLoading: () => void;
};

const LoadingPage: React.FC<Props> = ({ onFinishedLoading }) => {
  useEffect(() => {
    const loadingTimer = setTimeout(() => {
      onFinishedLoading();
    }, LOADING_PAGE_DISPLAY_TIME_MS);
    return () => {
      clearTimeout(loadingTimer);
    };
  });

  return (
    <Grid container justifyContent="center">
      <Typography variant="d2semibold" css={styles.headingText}>
        {_t('Finding the best courses for you...')}
      </Typography>
      <Grid item container justifyContent="center">
        <div css={styles.loadingIndicatorWrapper}>
          <TemporaryLoadingIndicator />
        </div>
      </Grid>
      <Grid item container justifyContent="center">
        <div>
          <SiteNotification title="" css={styles.siteNotificationOverrides}>
            {_t(
              "Did you know we have over 8,000 courses, projects, certificates, and degrees on Coursera? We'll recommend the right ones for you."
            )}
          </SiteNotification>
        </div>
      </Grid>
    </Grid>
  );
};

export default LoadingPage;
